import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../../common/helpers/AxiosClientFactory';
import { InsuranceHistoryReadModel } from '../../models/InsuranceHistoryReadModel';

export const getInsuranceHistory = (personId: number | string, insuranceId: number | string): AxiosPromise<InsuranceHistoryReadModel[]> => {
    return AxiosClientFactory
        .getInstance()
        .get<InsuranceHistoryReadModel[]>(`/api/applicants/${personId}/insurances/${insuranceId}/history`);
};
